import React, { useState } from 'react';
import { createPost } from '../services/postService';
import { incrementChannelPostCount } from '../services/channelService';
import MentionGuide from './MentionGuide';
import MentionAutocomplete from './MentionAutocomplete';
import './PostForm.css';

const PostForm = ({ user, selectedChannel, onPostCreated }) => {
  const [text, setText] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!selectedChannel) {
      setError('Please select a channel first');
      return;
    }
    
    if (!text.trim()) {
      setError('Please enter some text for your post');
      return;
    }

    if (text.trim().length > 1000) {
      setError('Post is too long. Maximum 1000 characters allowed.');
      return;
    }

    setIsSubmitting(true);
    setError('');

    try {
      await createPost(text, user, selectedChannel.id);
      await incrementChannelPostCount(selectedChannel.id);
      setText('');
      if (onPostCreated) {
        onPostCreated();
      }
    } catch (error) {
      setError('Failed to create post. Please try again.');
      console.error('Error creating post:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="post-form-container">
      <div className="post-form">
        <div className="post-form-header">
          <h3>
            {selectedChannel 
              ? `Share something in #${selectedChannel.name}` 
              : 'Select a channel to share something'
            }
          </h3>
          <MentionGuide />
        </div>
        
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <MentionAutocomplete
              value={text}
              onChange={(e) => setText(e.target.value)}
              placeholder="What's on your mind? Use @username to mention someone"
              rows="3"
              disabled={isSubmitting}
              maxLength="1000"
              onMentionSelect={(user) => {
                console.log('PostForm: User mentioned:', user.username);
              }}
            />
            <div className="character-count">
              {text.length}/1000
            </div>
          </div>

          {error && <div className="error-message">{error}</div>}

          <div className="post-form-actions">
            <button 
              type="submit" 
              className="post-button"
              disabled={isSubmitting || !text.trim() || !selectedChannel}
            >
              {isSubmitting ? 'Posting...' : 'Post'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default PostForm;